module.exports = __webpack_public_path__ + "source/img/robot-magic.df6bc2a2.png";